import { render } from "./ModalVideo.vue?vue&type=template&id=7216b0af&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"

import "./ModalVideo.vue?vue&type=style&index=0&id=7216b0af&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7216b0af"]])

export default __exports__